import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import { EpdBrandedIcon, EpdIcon, epdBrandedIconToUrl, epdIconToUrl } from '../../util/style-icons';

@Component({
  selector: 'app-icon',
  template: '',
  styleUrl: './icon.component.css',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'inline-block bg-center bg-no-repeat bg-contain',
    '[class.epd-icon-mask]': 'isMaskIcon()',
    '[class.epd-icon-background]': 'isBrandedIcon()',
    '[style.--epd-icon-url]': 'iconCssUrl()',
    'aria-hidden': 'true',
  },
})
export class IconComponent {
  public readonly icon: InputSignal<EpdIcon | undefined> = input<EpdIcon>();
  public readonly brandedIcon: InputSignal<EpdBrandedIcon | undefined> = input<EpdBrandedIcon>();

  public readonly isMaskIcon: Signal<boolean> = computed(() => this.icon() !== undefined);

  public readonly isBrandedIcon: Signal<boolean> = computed(
    () => !this.isMaskIcon() && this.brandedIcon() !== undefined
  );

  public readonly iconCssUrl: Signal<string | null> = computed(() => {
    const icon: EpdIcon | undefined = this.icon();
    const brandedIcon: EpdBrandedIcon | undefined = this.brandedIcon();
    const url: string | undefined = icon
      ? epdIconToUrl(icon)
      : brandedIcon
        ? epdBrandedIconToUrl(brandedIcon)
        : undefined;

    return url ? `url("${url}")` : null;
  });
}
